export const photosUrlEnum = {
  version: {
    normal: 'Normal',
    thumbnail: 'Thumbnail',
    secureOriginal: 'secureOriginal',
  },
  ext: {
    WEBP: '.webp',
    JPG: '.jpg',
  },
  placeholders: {
    ext: '.{{PHOTO_EXTENSION}}',
    version: '{{PHOTO_VERSION}}',
  },
};

export function compilePhotoUrl(template: string, version: string = 'Normal') {
  return template
    .replace(photosUrlEnum.placeholders.version, version)
    .replace(photosUrlEnum.placeholders.ext, photosUrlEnum.ext.JPG);
}
